<app-header-style-one></app-header-style-one>
<!-- <div *ngFor="let x of jobsScrollData" class="marquee">
    <marquee behavior="" direction="">{{x.message}}.</marquee>
</div> -->
<!-- <div class="marquee">
    <marquee behavior="scroll" direction="left" scrollamount="6">
         <strong>Job Updates:</strong>
        <span *ngFor="let x of jobsScrollData; let last = last">{{ x.message }} <span *ngIf="!last"> | </span>
        </span>
    </marquee>
</div> -->

<div class="marquee" style="display: flex;">
    <div class="container" style="display: flex;">
        <strong style="white-space: nowrap; margin-right: 10px;color: #fff;">Job Updates:</strong>
        <marquee behavior="scroll" direction="left" scrollamount="6" style="flex: 1;" onmouseover="this.stop();"
            onmouseout="this.start();">
            <span *ngFor="let x of melanotifcations; let last = last">
                <img src="assets/img/mepma/mic.svg" alt="" style="width: 24px;height: 24px;"> {{ x.mela_name }} <span
                    class="blinking"> *Apply Now* </span><span *ngIf="!last"> | </span>
            </span>
        </marquee>
    </div>
</div>
<!-- <app-homeone-main-banner></app-homeone-main-banner> -->
<!-- <app-about-page-one></app-about-page-one> -->
<!-- item-bg1 -->
<div class="page-title-area item-bg1">
    <!-- <img src="assets/img/mepma/banner.png" alt=""> -->
    <!-- <div class="container">
        <div class="page-title-content">
            <ul>
                <li>&nbsp;</li>
            </ul>
            <h2>&nbsp;</h2>
        </div>
    </div> -->
</div>


<!-- <app-homeone-about></app-homeone-about> -->
<!-- bg-image -->
<div class="courses-categories-area  pt-30 pb-70" style="padding-top: 30px;">
    <div class="container">
        <div class="section-title text-start">

            <h2>MEPMA-NIPUNA JOB MELA</h2>
            <span class="sub-title"> &nbsp;<!-- Last Date For Applying :07-10-2025 --></span>
            <a class="default-btn">
                <span>Entry Fees:
                    <span class="fee">₹100/-Only</span> </span>
            </a>
        </div>

        <section class="testimonial-outer padding-lg">
            <div class="tabs-container">
                <div class="pane" id="tab1">
                    <div class="col-lg-12 col-md-12">
                        <div class="courses-details-desc">

                            <div style=" overflow: auto;">
                                <div class="row">
                                    <ul class="nav-tabset">
                                        <li class="nav-tab">

                                            <div class="searchBar">
                                                <input id="searchQueryInput" type="text" name="searchQueryInput"
                                                    placeholder="Search" [(ngModel)]="serch" autocomplete="off"
                                                    (keyup)="applyFilter($event)" />
                                                <button id="searchQuerySubmit" type="submit" name="searchQuerySubmit">
                                                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                                        <path fill="#fff"
                                                            d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
                                                    </svg>
                                                </button>
                                            </div>


                                        </li>
                                        <!-- <li class="nav-tab">
                                            <div style="margin-bottom: 18px;">
                                                <ng-select placeholder="Select District">
                                                    <ng-option value="" selected disabled>Select District</ng-option>
                                                    <ng-option [value]="d.district_id"
                                                        *ngFor="let d of districtData">{{d.district_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </li> -->

                                        <li class="nav-tab" style="float: right;">
                                            <mat-paginator [pageSizeOptions]="[25,50,100]"
                                                showFirstLastButton></mat-paginator>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span> <strong style="color: #b51f00;">Note:</strong> <span class="blinkingnote"> *The
                                            entry fee for each JobMela is Rs. 100, regardless of the number of companies
                                            you choose to apply to. </span></span>
                                    <table style="margin-top: 12px;">
                                        <tbody *ngFor="let n of melanotifcations">
                                            <tr>
                                                <td style="text-align: left;padding: 4px 12px;"><strong>
                                                        Jobmela</strong></td>
                                                <td style="text-align: left;padding: 4px 12px;">
                                                    <b>
                                                        <span>{{n.mela_name}}</span></b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left;padding: 4px 12px;"><strong> Jobmela
                                                        Location</strong></td>
                                                <td style="text-align: left;padding: 4px 12px;">
                                                    <b>
                                                        <span>{{n.mela_location}}</span></b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="text-align: left;padding: 4px 12px;"> <strong>Jobmela
                                                        Date</strong> </td>
                                                <td style="text-align: left;padding: 4px 12px;">
                                                    <span>{{n.mela_date | date:'dd-MM-yyyy'}}</span>
                                                </td>
                                            </tr>
                                            <!-- <tr>
                                                <td style="text-align: left;padding: 4px 12px;"> <strong>Note</strong>
                                                </td>
                                                <td style="text-align: left;padding: 4px 12px;">
                                                    <span>{{'The entry fee for each JobMela is Rs. 100, regardless of
                                                        the number of companies you choose to apply to.'}}</span>
                                                </td>
                                            </tr> -->
                                            <!-- <tr>
                                                <td style="text-align: left;"> <strong>District Name</strong> </td>
                                                <td style="text-align: left;">
                                                    <span id="ContentPlaceHolder1_Label1">08/10/2025</span>
                                                </td>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                    <br>
                                    <table id="table-to-copied" #tab mat-table [dataSource]="dataSource" matSort
                                        multiTemplateDataRows >
                                        <ng-container matColumnDef="i">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass"> S.No
                                            </th>
                                            <td mat-cell *matCellDef="let row;let j = index" class="centre">
                                                <span class="para"> {{row.i}} </span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="company_name">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass">
                                                Company Name
                                            </th>
                                            <td mat-cell *matCellDef="let row"
                                                style="white-space: nowrap;text-align: left;">

                                                <span class="para" style="text-align: left;"> {{row.company_name}}
                                                </span>

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="position">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass">
                                                Position
                                            </th>
                                            <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                <span class="para"> {{row.position}} </span>

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="vacancies">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass">
                                                Vacancies
                                            </th>
                                            <td mat-cell *matCellDef="let row">
                                                <span class="para">
                                                    {{row.vacancies!=0? row.vacancies:'---'}} </span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="qualification">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass">
                                                Qualification
                                            </th>
                                            <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                <span class="para"> {{row.qualification}} </span>

                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="age_limit">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass">
                                                Age Limit
                                            </th>
                                            <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                <span class="para">
                                                    {{row.age_limit? row.age_limit:'---'}}</span>

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="salary">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass">
                                                Salary
                                            </th>
                                            <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                <span class="para"> {{row.salary?row.salary:'---'}} </span>

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="work_location">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass">
                                                Work Location
                                            </th>
                                            <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                <span class="para"> {{row.work_location?row.work_location:'---'}}
                                                </span>

                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                [ngStyle]="headerclass" style="width: 120px;">

                                            </th>
                                            <td mat-cell *matCellDef="let row" (click)="navigteApplyForm(row)">
                                                <span class="para" style="cursor: pointer;"><strong>Apply Now
                                                    </strong></span>

                                            </td>
                                        </ng-container>
                                        <!-- Footer start -->
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                            class="example-element-row clickable-row">
                                        </tr>
                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="7" style="color: red;">No data found</td>
                                        </tr>
                                        <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                            class="example-detail-row"></tr> -->
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section><br>

        <section>
            <div class="row" *ngIf="dataSource?.filteredData.length!=0">
                <div class="col-12" style="text-align: center;">
                    <button class="reg-btn" (click)="navigteApplyForm(melanotifcations[0])"> Click Here For Job Mela
                        Registration
                    </button><br>
                </div>
                <div class="col-12" style="text-align: center;margin-top: 18px;">
                    <button class="spot-btn"> Spot Registration Available at Mela Also </button>
                </div>
            </div>
        </section>
        <!-- <br>
        <section>
            <app-registrationform></app-registrationform>
        </section> -->
    </div>
</div>


<div *ngIf="showloader" class="overlap">
    <div class="loader"></div>
</div>